<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="6" class="gutter-row">
            <a-breadcrumb :style="{ marginBottom: '20px' }">
              <a-breadcrumb-item>
                <router-link tag="a" :to="{ name: 'servers' }">Servers</router-link>
              </a-breadcrumb-item>
              <a-breadcrumb-item>{{ this.$route.meta.title }}</a-breadcrumb-item>
            </a-breadcrumb>
          </a-col>
        </a-row>
        <template v-if="loading">
          <div class="loader-container">
            <a-spin size="large" type="loading" style="font-size: 50px;" />
          </div>
        </template>
        <template v-else>
          <a-row :gutter="40">
            <a-col :span="12">
              <div class="list-wrap">
                <a-list bordered>
                  <a-list-item>
                    <span class="title">System Uptime</span>
                    <span class="desc">{{timeAgo(server.system_uptime)}}</span>
                  </a-list-item>
                  <a-list-item>
                    <span class="title">Operating System</span>
                    <span class="desc">{{server.os_name}}</span>
                  </a-list-item>
                  <a-list-item>
                    <span class="title">Kernel</span>
                    <span class="desc">{{server.os_kernel}}</span>
                  </a-list-item>
                  <a-list-item>
                    <span class="title">Processes</span>
                    <span class="desc">{{server.processes}}</span>
                  </a-list-item>
                  <a-list-item>
                    <span class="title">Sessions</span>
                    <span class="desc">{{server.sessions}}</span>
                  </a-list-item>
                </a-list>
              </div>
            </a-col>

            <a-col :span="12">
              <div class="list-wrap">
                <a-list bordered>
                  <a-list-item>
                    <span class="title">CPU Model</span>
                    <span class="desc">{{server.cpu_name}}</span>
                  </a-list-item>
                  <a-list-item>
                    <span class="title">CPU Speed</span>
                    <span class="desc">{{server.cpu_cores}}x {{server.cpu_freq}}MHZ</span>
                  </a-list-item>
                  <a-list-item>
                    <span class="title">Total Outgoing</span>
                    <span class="desc">{{server.total_tx/1000000}} MB</span>
                  </a-list-item>
                  <a-list-item>
                    <span class="title">Total Incoming</span>
                    <span class="desc">{{server.total_rx/1000000}} MB</span>
                  </a-list-item>
                  <a-list-item>
                    <span class="title">Connection status</span>
                    <span class="desc">{{server.status}}</span>
                  </a-list-item>
                </a-list>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="40">
            <a-col :span="8">
              <a-card :bordered="false">
                <h3>Avarage System Load</h3>
                <h1>{{server.load_percent}}%</h1>
                {{server.load_average}}
              </a-card>
            </a-col>
            <a-col :span="8">
              <a-card :bordered="false">
                <h3>Current RAM usage
                  <a-tooltip placement="bottom">
                    <template slot="title">
                      <span>{{server.swap_usage /1024000 }}MB / {{server.swap_total /1024000 }}MB</span>
                    </template>
                    <a-button size="small" type="default">Swap</a-button>
                  </a-tooltip>
                </h3>
                <h1>{{server.ram_usage / 1024000}} MB</h1>
                of {{server.ram_total/1024000}} MB
              </a-card>
            </a-col>
            <a-col :span="8">
              <a-card :bordered="false">
                <h3>Overall disk usage</h3>
                <h1>{{server.disk_usage/1024000000}} GB</h1>
                of {{server.disk_total / 1024000000}} GB
              </a-card>
            </a-col>
          </a-row>
          <a-row style="margin-top:20px">
            <a-col :span="24">
              <template>
                <a-card title="Top Processes by Resource Usage">
                  <table class="simple-table">
                    <thead>
                      <tr>
                        <th>Command</th>
                        <th>Count</th>
                        <th>CPU</th>
                        <th>Memory</th>
                        <th>User</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="process, index in server.processes_array" :key="index">
                        <td>{{ process.command }}</td>
                        <td>{{ process.count }}</td>
                        <td>{{ process.cpu }}</td>
                        <td>{{ process.memory }}</td>
                        <td>{{ process.user }}</td>
                      </tr>
                    </tbody>
                  </table>
                </a-card>
              </template>
            </a-col>
          </a-row>
          <a-row :style="{ marginTop: '10px' }">
            <a-card title="Server Histories & Stats" :style="{ paddingLeft: '10px', paddingRight: '10px' }">
              <a-tabs defaultActiveKey="1">
                <a-tab-pane tab="Network Usage" key="1">
                  <network-usage-graph :server="server"></network-usage-graph>
                </a-tab-pane>
                <a-tab-pane tab="RAM & SWAP" key="2">
                  <ram-swap-graph :server="server"></ram-swap-graph>
                </a-tab-pane>
                <a-tab-pane tab="Disk Usage" key="3">
                  <disk-usage-graph :server="server"></disk-usage-graph>
                </a-tab-pane>
              </a-tabs>
            </a-card>
          </a-row>
        </template>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Sidebar from "@/components/Sidebar.vue";
import NetworkUsageGraph from "@/components/NetworkUsageGraph.vue";
import DiskUsageGraph from "@/components/DiskUsageGraph.vue";
import RamSwapGraph from "@/components/RamSwapGraph.vue";

export default {
  data() {
    return {
      columns: [
        {
          title: "Process",
          dataIndex: "command",
          key: "command"
        },
        {
          title: "Count",
          dataIndex: "count",
          key: "count"
        },
        {
          title: "CPU",
          dataIndex: "cpu",
          key: "cpu"
        },
        {
          title: "Memory",
          dataIndex: "memory",
          key: "memory"
        },
        {
          title: "User",
          dataIndex: "user",
          key: "user"
        }
      ],
      loading: false,
      interval: null
    };
  },
  components: {
    Sidebar,
    NetworkUsageGraph,
    DiskUsageGraph,
    RamSwapGraph
  },
  methods: {
    timeAgo(time) {
      let formatTime = moment.unix(time);
      return formatTime.fromNow();
    },
    async dispatchActions(refresh = true) {
      if (refresh) {
        this.loading = true;
      }
      await this.$store.dispatch("servers/GET_SINGLE_SERVER_DETAILS", {
        key: this.$route.params.key,
        server: this.$route.params.server,
      });
      this.loading = false;
    },
    refreshJobsPeriodically()
    {
      this.interval = setInterval(() => {
        this.dispatchActions(false);
      }, 180000);
    }
  },
  computed: {
    ...mapGetters({
      server: "servers/getServerInfo"
    })
  },
  created() {
    this.dispatchActions();
    this.refreshJobsPeriodically();
  },
  destroyed(){
    clearInterval(this.interval);
  }
};
</script>

<style lang="css">
.list-wrap {
  background: #fff;
  margin-bottom: 40px;
}
.list-wrap .ant-list-item-content {
  display: flex;
  justify-content: space-between;
}
.list-wrap .ant-list-item-content span {
  /* display: flex;
    flex: 1; */

  font-size: 15px;
}
.list-wrap .title {
}
.list-wrap .desc {
}
.inner--card { border: none; }
</style>


